import { Directive, ElementRef, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';
import { TextUtils } from '../utils/text-utils';

@Directive({
  selector: '[elxCapitalize]',
  standalone: true,
})
export class CapitalizeDirective {
  constructor(private el: ElementRef, private control: NgControl) {}

  @HostListener('blur')
  onBlur() {
    if (this.control && this.control.control) {
      const value = this.control.control.value;
      const capitalizedValue = TextUtils.capitalizeWords(value);
      this.control.control.setValue(capitalizedValue, { emitEvent: false });
    }
  }
}
